import { Component, Prop, VModel, Watch } from 'vue-property-decorator'
import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import ProjectMixin from '@/_mixins/project'
import UserMixin from '@/_mixins/user'

@Component({
    mixins: [ProjectMixin, UserMixin],
    inheritAttrs: false,
})
export default class DateTimePicker extends Mixins<MixinInterface>(ProjectMixin, UserMixin) {
    @VModel({ required: true }) dateAt!: string | null

    dateMenu = false

    get date() {
        return this.dateAt
            ? this.formatDate(this.dateAt, this.getDeviceTimeZone, 'YYYY-MM-DD')
            : null
    }

    set date(date: string | null) {
        this.dateAt = date
            ? this.formatDateTimeWithTimeZone(date, this.time, this.getDeviceTimeZone)
            : null
    }

    get time() {
        return this.dateAt ? this.formatDate(this.dateAt, this.getDeviceTimeZone, 'HH:mm') : '00:00'
    }

    set time(time: string) {
        this.dateAt = this.date
            ? this.formatDateTimeWithTimeZone(this.date, time, this.getDeviceTimeZone)
            : null
    }

    get locale() {
        return this.$i18n.locale
    }
}
